import { query, where } from "firebase/firestore";
import { useState, useEffect } from "react";
import { GlobalDataTypeData } from "../../to-be-removed/LocalData/Company/GlobalDataTypeData";
import { LocalData } from "../../to-be-removed/LocalData/General/LocalData";
import { CollectionLoadedListener } from "../../to-be-removed/LocalData/General/CollectionLoader";

export const useGlobalDataTypes = () => {
  const [dataTypes, setDataTypes] = useState<GlobalDataTypeData[]>([]);

  useEffect(() => {
    const companyIDs: Set<string> = new Set();
    for (const company of LocalData.currentUser.companies) {
      companyIDs.add(company.id);
    }
    for (const property of LocalData.currentUser.properties) {
      for (const company of property.companies) {
        companyIDs.add(company.id);
      }
    }

    const listeners: CollectionLoadedListener<GlobalDataTypeData>[] = [];
    for (const companyID of companyIDs) {
      listeners.push(
        LocalData.dataTypes.setupRealtimeListenerWithFilter(
          (ref) => query(ref, where("companyID", "==", companyID)),
          (docs) => {
            setDataTypes(LocalData.dataTypes.documents.filter((d) => d.companyID && companyIDs.has(d.companyID)));
          }
        )
      );
    }

    return () => {
      for (const listener of listeners) {
        listener.removeListener();
      }
    };
  }, []);

  return { dataTypes };
};

// Same as above, but load and not realtime
export const loadAllGlobalDataTypes = (): Promise<GlobalDataTypeData[]> => {
  const promises: Promise<void>[] = [];
  const companyIDs: Set<string> = new Set();
  for (const company of LocalData.currentUser.companies) {
    companyIDs.add(company.id);
  }
  for (const property of LocalData.currentUser.properties) {
    for (const company of property.companies) {
      companyIDs.add(company.id);
    }
  }

  for (const companyID of companyIDs) {
    promises.push(
      new Promise((resolve) =>
        LocalData.dataTypes.loadWithFilter(
          (ref) => query(ref, where("companyID", "==", companyID)),
          () => resolve()
        )
      )
    );
  }

  return Promise.all(promises).then(() => {
    LocalData.dataTypes.loaded = true;
    return LocalData.dataTypes.documents.filter((d) => d.companyID && companyIDs.has(d.companyID));
  });
};

